import { Plus, X } from 'lucide-react'
import { useState } from 'react'
import { cn } from '../../utils/cn'

// Bloco "NOSSOS PRINCÍPIOS" (Cultura Omnicore, frames 585:8619/585:8522):
// eyebrow + lead com barra lateral + accordion numerado 01..N com toggle +/×.
// items: array de { title, body }
export default function CulturePrinciples({
  title = 'NOSSOS PRINCÍPIOS',
  lead = '',
  items = [],
  accentBorderClass = 'border-[#2862B9]',
  iconClass = 'text-[#2862B9]',
}) {
  const [openIndex, setOpenIndex] = useState(-1)

  const toggle = index =>
    setOpenIndex(current => (current === index ? -1 : index))

  return (
    <div className="w-full px-20">
      <h2 className="pt-10 pb-6 font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
        {title}
      </h2>

      {lead && (
        <div className={cn('mb-8 border-l pl-7', accentBorderClass)}>
          <p className="font-inter-regular text-base leading-[1.08] text-[#454545]">
            {lead}
          </p>
        </div>
      )}

      <ul className="flex flex-col pb-12">
        {items.map((item, index) => {
          const isOpen = openIndex === index

          return (
            <li key={index} className="border-[#D9D9D9] border-t">
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => toggle(index)}
                className="flex w-full items-center justify-between gap-6 py-5 text-left"
              >
                <span className="flex items-center gap-6">
                  <span className="font-inter-regular text-lg leading-[27px] tracking-[-0.02em] text-[#AEAEAE]">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
                    {item.title}
                  </span>
                </span>
                {isOpen ? (
                  <X size={22} className={cn('shrink-0', iconClass)} />
                ) : (
                  <Plus size={22} className={cn('shrink-0', iconClass)} />
                )}
              </button>

              {isOpen && item.body && (
                <p className="pb-6 font-inter-regular text-xl leading-[30px] text-[#000000]">
                  {item.body}
                </p>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
